export const blockIconsAndroidWifiOffNew = (
	<span className='material-symbols-outlined'>wifi_off</span>
);
